var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{on:{"&scroll":function($event){return _vm.onScroll($event)}}},[(_vm.dialog)?_c('Dialog'):_vm._e(),_c('v-content',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }